import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetDatabases } from 'domains/Database/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../CustomerFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const DatabaseFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [databases] = useGetDatabases()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'database',
    operand: '=='
  })

  return (
    <StyledDetails
      open={localStorage.getItem(`database-details-visibility`) === 'opened'}>
      <summary
        style={summaryStyles}
        onClick={() => onToggleDetails('database')}>
        {t('Database')}
      </summary>
      {databases?.map((database, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(database)}
            onChange={() => onChange(database)}>
            <Text wordBreak="break-all">
              {database?.dataModels || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

DatabaseFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default DatabaseFilter
